
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIBAzVei4_fnsUj7nb04QPr1aK_45sfxS_45av09Twb6wqfAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/index.vue?macro=true";
import { default as loginFbde5jsl2bFXl9yab4MUa_45ekReYZOd3FEuFpiqTBA5YMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/login.vue?macro=true";
import { default as _91key_93MFKKQdF2Ok8ES1HpKi1irQYe6MRmMiO8C_Gk_45mQslusMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/s/[key].vue?macro=true";
import { default as mgenN86Q9KXzXc00vNqFlztDvBqwIbwtc6kKUOBQRTFBpd4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/mgen.vue?macro=true";
import { default as indexCOTo2ksvslkiIpMkxdtnWIcX16JG1JRs1SyfA7Iur9MMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/index.vue?macro=true";
import { default as notesSg_EzgyJvm5c8Gw2GJGCl0R7d4sGQWrfM8Ga7qFGG7sMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/notes.vue?macro=true";
import { default as indexFtA0CkJEWxirZOFtEGWYz_ob_arsrqGMNBOLsG3kyD4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentLUF_b80IAcjghf25Hq5OUXYX6iKIxbcoVX8AwACD_TcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45sitekoiwyCrnm2CkbAlKVovX_YrFDnbElLPLj7QTW0U7pEMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/plan-du-site.vue?macro=true";
import { default as editFtgqtXThutMl84D9lZQAhtaHCLnSP0iDoAFPd74l_45XkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/edit.vue?macro=true";
import { default as placesufqfj1rfhMhyszlY3SFu8JwQFLffnol8SYHRoFv0yJsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/places.vue?macro=true";
import { default as accessibilite07d8ub9TAhKHf4DZszFNWG4E4zv4X36gX52UBz_nhEEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/accessibilite.vue?macro=true";
import { default as _91id_93DNR2Q4N3f1pPj_IIPT_45kjdRKmgSiD2R5S_45d_mlPW0c4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/[id].vue?macro=true";
import { default as notificationsFdRYwj7f2ZqrHVvFmhk5TQcxzVU_45Y9kr_2jLkv_45vNKEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/notifications.vue?macro=true";
import { default as indexKDstuhSS_45CaU9QNdtyQmArYByrLNDhmiqQHLH4pv2l0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/index.vue?macro=true";
import { default as indexf06n7rS_45L_4PRZtGePGJ_4_45QYlun_45u7TDze1PNasD5wMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/index.vue?macro=true";
import { default as _91slug_93321NuoRG1Q5AL525GYzHFvnlrkfdTnw11nt5XpRZuQIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/villes/[slug].vue?macro=true";
import { default as indexm0BrI4EWCCITL6D46Oe0KHFzHOaHt6lByvDoCMrpRw0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/index.vue?macro=true";
import { default as generiquezCAx8YfRHyKdh9Q5RhE0PgsUOHu3C7cfuzIBc26YCG8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93UIgtJx2ygMWeT4Z396JuTykSyT2OKl2eKci1Xvgpx48Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/reseaux/[slug].vue?macro=true";
import { default as missionsKUafc0cZDzdzkdW1HCyF_Bj668f0eJIrKcq_45CnLQ21IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/missions.vue?macro=true";
import { default as indexidm8FqB_IOojAl8AJweUHK2T3YQNF70FSihNDflh_zcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/dashboard/index.vue?macro=true";
import { default as favorisdnRs9ho36_45NKg46_45LjUW8Z3iRBqABpIhxLlFqSl5bWoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93aMxw0PbvAAwyKlnD5hLAsSeF0U5FurO_457CQcq2iZH_458Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/activites/[slug].vue?macro=true";
import { default as logszRtX0KgZ6GAGX9qm7BMUL6F19LoEuSwqsrTS3Rg_MpYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesgJWGBox4BnWaZjiZd12zlD61fUW9jw6X8uxkO5aO8F8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesPjmcPCgBeVv5h6N5tRIrRbkE2xorALt6wym6B6DJKDsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/mentions-legales.vue?macro=true";
import { default as missionsNenqHSCiJjTbyo36ncf6tL1FXoHnPGr4svZU2YGuPC0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/missions.vue?macro=true";
import { default as settingsYbQsdfcSTjBDhpFpj2AGCfC2LqNslzLg0cWYiH_45JUtwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/settings.vue?macro=true";
import { default as tournee_45eteOYwWueVpbSPmyrP4n5DseIAJiA3UPaWnPGmcs_45Z6kMAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignages3fEMyptnwSmTsqeFtnMJ18oV_hmCxDf13_45gd7X173ZwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/temoignages.vue?macro=true";
import { default as indexmpvAykrHZLqhG2NnPmm8xQlLkjPVBvNgR3iM2GnRwq4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/index.vue?macro=true";
import { default as adminZjnnNmMPhdR_dE95CFaaTMIhIsoEwMD5uZDBnccG3JkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/maintenance/admin.vue?macro=true";
import { default as indexK58Xx6Gjx7kKshsais5EJ9g0pJdFTiK4RmSq1FD1BKIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/maintenance/index.vue?macro=true";
import { default as indexs4vHNPqqgZGlDnhFaTeS0FA4kvre74t_CYJu_45uLng_wMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/territoires/index.vue?macro=true";
import { default as _91hash_93HRLMwhHEZnkU526Ys6Sq_45Q7AcrAs0Xos_4jIzgEWZ98Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursKpoqwi5dx4OFAgDTBwwSnPGHIb63fu1TxxdeXWBogYcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93KP0AW73X_te2_45BfjErvTTpz_AhNw8Nyb_45FK9nllDBh8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93TjCTvmM2CuA2ormrIpGqy5QZ9ClG_45rz5uhdUiZxDcOsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/departements/[slug].vue?macro=true";
import { default as indexUAPhCyRoVRFN2N6SjVmISfohxAueSrdL76AtCbpnhusMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/organisations/index.vue?macro=true";
import { default as preferenceskWkskm3VQUJU3b54WDjc1XN9RMjeM5vWU4DihoMMxxEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/preferences.vue?macro=true";
import { default as organisationsiX2EH1H3tZjTkpY_4Te1UvW3t2z_45rOiQdUyViS_KpOIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/organisations.vue?macro=true";
import { default as _91token_933AFZ_PjGG1e_45_45YsatblCPTId6CbWnSBkZmck1RXmjbcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/temoignages/[token].vue?macro=true";
import { default as postsPe9iW6YrK_1KXioTryPSvxwacSFFou969AbMAQ0thb8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/posts.vue?macro=true";
import { default as indexlIZjt8bw7yILl12DQx5HdbpcnNGe7kP_y1WD2RikuIMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/index.vue?macro=true";
import { default as addA4SAE1aRxy5ZzNwxiKVZ0WuRZ5fqIGPLuCNWiau6_YEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93iZdRY2h3Kr3rF4KGe8AjHlDfjK8k8LAkmue_G2CtP0AMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/organisations/[slug].vue?macro=true";
import { default as indexivqZU2VdV5oHkjg4jGrqGn3zLoC2gYXFIJqQOdDDoLUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/password-reset/index.vue?macro=true";
import { default as participationshphGp0FiKezwGEeAhp5nH5RdS1xaqtjP2hMoiBqEhnsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/participations.vue?macro=true";
import { default as emailsc0Iv3Kh2GDNXIjEIgJMpF63ZMy9aPNfymW_1aYol6TMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/emails.vue?macro=true";
import { default as indexFE0nSO0_451zYmV_bfE_CFrAKKnlMRy_45qVGMzoq_4NEm4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsja9eP9zMoCTOIEnsoCcWYUVdjqU6wV4Y5na87FtgNmUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/notifications.vue?macro=true";
import { default as indexo1ZjeEB4EA4UhcWnkeY_45pOKK2setxY1h7N5WLvI0TicMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueMv7eDoCnc4_BFGucl8JfxaUHaSWoouKOqDOfwbp1_psMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93fPOwWJ1lh8Ew5O5zGZP5fJGkuCUi6UYfDWEUedMwsuAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/domaines-action/[slug].vue?macro=true";
import { default as indexFRz1s3Dx3fOxhO5GTRJhfAkTnmkUrLOEVfOZZojtfeQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93XSmQ0lpjsAZ5QyxWSkngk8zvsYjjW2kWsPJrXyNsKM8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleZiZLm8RsEVVuT_94UGunGgxd8wUdWZNIdo8arpW62a0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsXTGZc8wTJT6HOeY1w7dMGHjPtGYtW8hj0wZMlsaYokEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/other/invitations.vue?macro=true";
import { default as messagestNH7i_45TSh5eN2liWyAq3vkVqdzdjBxo1wfxyX68_k7IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/messages.vue?macro=true";
import { default as places44gtoQWWtlh3_45TgwMoX_45djWELqHL8krL133r_6Lb7gwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/places.vue?macro=true";
import { default as addEB4hLLncSZZmQSR_45qD4v5xfO6Rqz6BLbsVjeIO66WfMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexf0AvTr60iA8dJK6c7D2hlk_45XpBny0fhsxv2aqnax_457YMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/index.vue?macro=true";
import { default as index0cebpo5yz99HK_a8T_451ojcfvIwMSvwJxww_45dYJZIcuUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/index.vue?macro=true";
import { default as datesZAJU0yASVK3Sfu8wjUFaDFlb11429Ynq8tEqoqvmtSoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexD497j6xRgtlS85NAsXbic_t9Zhm9LF4CPyJk1NuCQbYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxconsXfbMznftwud6MvmbCgSNje22nn9J9sYha7vl9GcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleIAGOO8pmbNycF87w_Ybqp_45spD76rEC87YmYimIBpbfsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexDx0L3_45fNyfg5JK9R572pnX_45IUi_p0dxKnQRsh0L2lk4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/index.vue?macro=true";
import { default as missionsIIcAwCnHYgu6v8SDoC3QjuYYwXJMkF8uF3hQqDkX05IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/missions.vue?macro=true";
import { default as addP2XGcymFIKJ3bDS3bouUMFBA2uvMQVOQUF_45I6aMUTDQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visueljBeM1ERAgj4Cnzlo3nC6vwGpsM9Y_nz71WNsKclTu1IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexE1zziKIy0fZ_qfhoEiql3Wdux815r0B59RMhc_qsFcYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/participations/index.vue?macro=true";
import { default as index4jIFaX3fgYj2N_45hKe4zAbCV8PzlnC0jAPfDh_45LkAYiYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexeVxIZ9TF06gvYAX1rLUq7tYosw6WkYs9sX2sfSR31KoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/index.vue?macro=true";
import { default as addy59XrzIB5KEmxQrGURW_45_I5v936Ys1hAPi74GKYCodwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addFUnJPhxiuqGIWjx3aUhy_45DKRc8QOqPL2DOO4mEQuko8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addnjXNycnLQKK_458AUgsWiq_45USAnxKshMz44_e10_45ePwOoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexGcTdhJC1m93oEkvkej2mkAt4OohvuH0MO6YN9xzPweAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsDyVIo8V05J5aoM7jzxCkW0nTCxIGMLz7lemSdrzYsesMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/conversions.vue?macro=true";
import { default as editMh2XGfYOIZRFDRF4RojKXN08xoTWufdaqZPSny7ogcEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialitexrSrluP9XKJyEgnzBaO7KFvh5oDdMSGpfHfpPSuP9ZAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexJ7qKhX6oIkDJGFyGnNEuK8FGNtamTU04Wcg6TB_LNrsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addgUhckEiuywdyzAKkIgITTEUSrrPP_z5PBiUNuCNcxCoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesb9zIV881KBlBZw_pEBQZtMPgDFVRUTvRw7ISVf4LJkkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editWZoJYwZ_45cmY7LhuLMwzfhj_45v3XZQ6D3hC2F29B2pcUAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursLwK_R1jXAZTRBqHHdu1cpZKbBQGk_45dMiFoGNGwHF7zUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexeyNUU5Qf_45KA9un9KoW5xXsUq5nUlghXrFq5mKYRi_45SwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexy_lAAEigUQAVTt9N2uMcte_Sivb7cj7ithcxACwDmpwMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexr8IH0cMds1IdsXEe5K00pPwQJ5UkIetk41U5c_45fA6NIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/index.vue?macro=true";
import { default as indextmWVjNBNGTohNYY0SO4YmCdh0wNRky9t267V3wXhZfYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendreYpPxImqdFuKIsgbjoHA4SGBEAt6mYPHhVu8QyvQq92IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexY9YgqWw9au2xUnT1GC3FF0IwinVJB4sqTejoGYaZbqYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/index.vue?macro=true";
import { default as adddt9FXVg9SPUKzNIibhEyJPJhuMbtGAa6NllwZm7O48EMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexWQKy__0Ip8e_45XfmhSiJk_YU3ss1yGdhX9x5hbcVUGJIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as edithW86l2DQJzpVTcp2aT_45bN5bw4LgqQYb3Ms0XHvP_LSAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93f4QL9n_45Bnp_45qFuuF7jTABCLGpKqTjVEAuSh__45w1tjvEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteUqgtnn96Zsbd0umwXLJWXiXm4_6WZTf62uMgTukH4agMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexQ_45M_45wgYh7ZDCJBAR1kS4azxpybgF4DiyeaezB4F9VvkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participations2PyeTKGfELFcgaZK5bnJGrdWLncX11B7y7u3tL8FlicMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/participations.vue?macro=true";
import { default as indexIFW8bVTCOm9BfRK6GTXu_45wyjLLWMth4UDzQYhmJUPmcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsEG7Q1XPHzA1LrejtpbjEJAfWc6jFYjKGaGdfpq2KPmQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/referents/activity-logs.vue?macro=true";
import { default as editNjsUX4_45DUd8PKNywPv7ucInxIrowCAVOMshPlrj1o90Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexRAByBC9rGsgxxlc0OkY_45IhFiSrPKdk6wtgu1t0SwKmEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsP0WfxwnVPS4yyfe40KDqDvF1JW4XAqNFJoC9gjikTw4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesnTk0q_ib66CXZGkfyvsfUd6y5DnIGdHko6agph5inxMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editRBi7qPPIqdBT2qgHpu0OfH51usZMJlOjAmnntLhrIfoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexyLimMLC0aV4Q2b10KKZzZFy9Vr_ajxDS5ICSxAT9jkIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexO6_45nM6xSThsODs1gAJSjWPlK1PD8R1_qsus_M3JgLS8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesht4OBZqKDrHyScdxGXS_457ZP2vsNILe9o775U3ph8xzYMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editka1Sjfya7Q0RbLwML3yJ1k_45voYORBvaQcz5vPXgOHCoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profile9ixpdxGHo5FUZqRZsTQHunL_H_45XaSyAwVS_45Dm1r3h0gMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnement5E6omecSeSfCNe4ofeCH0jGaCF5QDlqQ0csiStnVNMoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsOZWX45ZNo4h_wdGiWmoKIJMjigk_UvcrvLb5BW2wos8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editk4tq7YiAFcgjjLewo2TkwS3km1iV6qiYoHseHgpXAEgMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as add8cgfq52YR8RdwquxDJrHcARqgnKr3ouNt7csN2kYaSAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationYQzPCibCpDkkiEMSlL2nC__452rhAvvINZDtlJfHTmg08Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexUR66kYKv4ZSOrpPE5OhfFmDq_l3t6C22oAQzoGVAyLgMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edit6k6Ua1_WkSrMGAL1sxnNQLT723Vfb42lxq7nrU_45oTMcMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsK0E6k5OibOnXGE46W3W73NA_45wgAw5jowASToeQIHCNkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsRKSh3x9eLt6i0Arxt1b2izCdPqaCGii9o_45bMjPtyw4YMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesb2lgC8dECUp656vpNHBTcSou9xsHTSN4SAPrjJIo8kkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingsESntuq_uPq2g2jS4WlT9U92_36XdSBEYBmbP6pUq6oMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexSSmFmiKVcgTahMl_hmrq9L6uoGvf9e9l9Kn1OKiBp8MMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editufKpGbiockZhUZl_0ptYe_tkzvTPNhvAd38ynK8l8KIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as index5uafpWu1KAFNl28ChqLGLgVYVMhqDHY8BkYMS_17FI0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profilez7uOOPPu5Xowpu8DFfciTfYVb9nndEzMOZgSpn4xmskMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexxsE4rN6nbKdMpgNw4pouO8K3MxkSg0vhb20PnwnH0noMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editIXsSHe8WWtJGWcT3sqiTADGWA7vEHx2jz9QXtgG7ZXQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addzcPEJXtB0OUSRP3Z0SIZNp_45ab1bYO5Dr19DQH3aerf8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesmI8wTwI70tPHvxdJu66D3o9qjabcntQUvytADnrc4EAMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesofHDPuZ6I3AYgNdIbS_Nq4DNBfoz1ZFn5dRg6z7Gl_45IMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45users_45CukM_YwIXeKCqqR5dL7eCywvBu8UrU7H_45KHfruqai0Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresJ0_45jaP1QVb4XhPktHWzlMAz_45bDunfTJIHY7hxLPo5moMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsables3kKCj7ezg8BszsnKQ5L0lx5_h875QNXifgk9AMoafE4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationknr3rdKT1mZuyrLnk1_45j79CHsGj9_45csnPnxt8pC8z_oMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedUtXOAJqyXDYoo_mXUncxVr9Scl6Uz6oBd392s7sm8hEMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsTCYxJWNCRKGGVGj_ViIcm2EDbNUB4XjZJbsNh_zE4okMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45rolexDnvi8zbeANGS0tmhplX8i8grFy5YOCwS2aY3FA9L_wMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsDY6c3dHfbvBwkZUxJLJVtoV_45CremJ8X9jJRMTVdJN0YMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editIV6g1Q9LPvDXwhjV12lb51OtBxI_Y5I2aZxvDLRczX4Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilites9YiiiwDYASxh9gdCMqKTOWP5hB3Fx2HYK2Cp6_45gezJUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkTf_45PcYT8Ws9frBnjfzPepW42oXh7iFdykj1skQhaPbUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index_yAvIJCYoo729x6rSoKapzUZvM4rgQN75X5AhIumXjUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivite31AJyQkf01AnvRWdQDRvC4InZk96ybeRZNCoAAJmlrIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationQmkEz2QhoOGKYQI243Yiu3WQ_QKcwKtjDlDNtoYab0oMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informations4dkd9lMKi_bJOpspooP9N7x2QtAfFznh7HXPX81D7U8Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantOMcDlPKDQ2P10pw05yaWWuUwVwm_29t4zRK3oMq7ZhsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortant1sRhoDd6jXW_4508nR1G99dwaFUFxudqxuGTYCXeOmFvMMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexjd8QoYXVqlm3r_45P4XlHiMnt3Z_Bto9sA9aJYvtI0KaUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesa2aXCqbGGBYI6mEv1zl3DOqGmv8KLXNdkOhuWA_45hWDQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerlF4ECvJut_45tpmx54C4IzXjrIGUXCcNPLotHGuhDhH8wMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesUlkvf5aKdbQ4baegHbsLs7QI9_DhWyv1tu7ddRoqH6QMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesQW9QBHKUAmhKmEb3fNfYSPfzGDc7IdB4Fz2HNmGvuGkMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsmO3_DKD6H1_45xqpJRf4njsy5EQjKt7vFlSddlcYk2SjIMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedLrX7iKG_45qkMVBAoJVINK_45jDvKgaUCRPirYWn_xBYUCQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectI_452_45ZjPhPDWBkVj8pgLFBP_45YK4CrEvtwNoZLMpD00JQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valider8wXgrsnCj7asxtxQkm9H1Z2SkMPE4jLWR_fbMqKT_ykMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementkN9gPVD_45W7v5Pik4DOnETG4YQYzItU6HdkXxfQjo7AQMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationDR7luGtiBt3toOnI6P_45Ywyog7r4QEwAulZOPB2C1T8MMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationtuOl5BBU4_TWfni6y9LibB6AofTsj5jjrFiJL89ZX60Meta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerusQBbC5laCVfYDeNoO1PIGzXj5RJJLnL622S_BjKfjsMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesT6cB7vptXVm6Pg16QBz6xtPmHWR6yqmTLCJoat7yPvUMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo } from "/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginFbde5jsl2bFXl9yab4MUa_45ekReYZOd3FEuFpiqTBA5YMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/login.vue")
  },
  {
    name: "s-key",
    path: "/s/:key()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/s/[key].vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenN86Q9KXzXc00vNqFlztDvBqwIbwtc6kKUOBQRTFBpd4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexCOTo2ksvslkiIpMkxdtnWIcX16JG1JRs1SyfA7Iur9MMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesSg_EzgyJvm5c8Gw2GJGCl0R7d4sGQWrfM8Ga7qFGG7sMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexFtA0CkJEWxirZOFtEGWYz_ob_arsrqGMNBOLsG3kyD4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editFtgqtXThutMl84D9lZQAhtaHCLnSP0iDoAFPd74l_45XkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesufqfj1rfhMhyszlY3SFu8JwQFLffnol8SYHRoFv0yJsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93DNR2Q4N3f1pPj_IIPT_45kjdRKmgSiD2R5S_45d_mlPW0c4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsFdRYwj7f2ZqrHVvFmhk5TQcxzVU_45Y9kr_2jLkv_45vNKEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexKDstuhSS_45CaU9QNdtyQmArYByrLNDhmiqQHLH4pv2l0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexf06n7rS_45L_4PRZtGePGJ_4_45QYlun_45u7TDze1PNasD5wMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexm0BrI4EWCCITL6D46Oe0KHFzHOaHt6lByvDoCMrpRw0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiquezCAx8YfRHyKdh9Q5RhE0PgsUOHu3C7cfuzIBc26YCG8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93UIgtJx2ygMWeT4Z396JuTykSyT2OKl2eKci1Xvgpx48Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsKUafc0cZDzdzkdW1HCyF_Bj668f0eJIrKcq_45CnLQ21IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexidm8FqB_IOojAl8AJweUHK2T3YQNF70FSihNDflh_zcMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisdnRs9ho36_45NKg46_45LjUW8Z3iRBqABpIhxLlFqSl5bWoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logszRtX0KgZ6GAGX9qm7BMUL6F19LoEuSwqsrTS3Rg_MpYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsNenqHSCiJjTbyo36ncf6tL1FXoHnPGr4svZU2YGuPC0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsYbQsdfcSTjBDhpFpj2AGCfC2LqNslzLg0cWYiH_45JUtwMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45eteOYwWueVpbSPmyrP4n5DseIAJiA3UPaWnPGmcs_45Z6kMAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexmpvAykrHZLqhG2NnPmm8xQlLkjPVBvNgR3iM2GnRwq4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminZjnnNmMPhdR_dE95CFaaTMIhIsoEwMD5uZDBnccG3JkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexK58Xx6Gjx7kKshsais5EJ9g0pJdFTiK4RmSq1FD1BKIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93HRLMwhHEZnkU526Ys6Sq_45Q7AcrAs0Xos_4jIzgEWZ98Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursKpoqwi5dx4OFAgDTBwwSnPGHIb63fu1TxxdeXWBogYcMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferenceskWkskm3VQUJU3b54WDjc1XN9RMjeM5vWU4DihoMMxxEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsiX2EH1H3tZjTkpY_4Te1UvW3t2z_45rOiQdUyViS_KpOIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_933AFZ_PjGG1e_45_45YsatblCPTId6CbWnSBkZmck1RXmjbcMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsPe9iW6YrK_1KXioTryPSvxwacSFFou969AbMAQ0thb8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexlIZjt8bw7yILl12DQx5HdbpcnNGe7kP_y1WD2RikuIMMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addA4SAE1aRxy5ZzNwxiKVZ0WuRZ5fqIGPLuCNWiau6_YEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93iZdRY2h3Kr3rF4KGe8AjHlDfjK8k8LAkmue_G2CtP0AMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexivqZU2VdV5oHkjg4jGrqGn3zLoC2gYXFIJqQOdDDoLUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationshphGp0FiKezwGEeAhp5nH5RdS1xaqtjP2hMoiBqEhnsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsc0Iv3Kh2GDNXIjEIgJMpF63ZMy9aPNfymW_1aYol6TMMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexFE0nSO0_451zYmV_bfE_CFrAKKnlMRy_45qVGMzoq_4NEm4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsja9eP9zMoCTOIEnsoCcWYUVdjqU6wV4Y5na87FtgNmUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexo1ZjeEB4EA4UhcWnkeY_45pOKK2setxY1h7N5WLvI0TicMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexFRz1s3Dx3fOxhO5GTRJhfAkTnmkUrLOEVfOZZojtfeQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93XSmQ0lpjsAZ5QyxWSkngk8zvsYjjW2kWsPJrXyNsKM8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleZiZLm8RsEVVuT_94UGunGgxd8wUdWZNIdo8arpW62a0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsXTGZc8wTJT6HOeY1w7dMGHjPtGYtW8hj0wZMlsaYokEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagestNH7i_45TSh5eN2liWyAq3vkVqdzdjBxo1wfxyX68_k7IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: places44gtoQWWtlh3_45TgwMoX_45djWELqHL8krL133r_6Lb7gwMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addEB4hLLncSZZmQSR_45qD4v5xfO6Rqz6BLbsVjeIO66WfMMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexf0AvTr60iA8dJK6c7D2hlk_45XpBny0fhsxv2aqnax_457YMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: index0cebpo5yz99HK_a8T_451ojcfvIwMSvwJxww_45dYJZIcuUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesZAJU0yASVK3Sfu8wjUFaDFlb11429Ynq8tEqoqvmtSoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexD497j6xRgtlS85NAsXbic_t9Zhm9LF4CPyJk1NuCQbYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxconsXfbMznftwud6MvmbCgSNje22nn9J9sYha7vl9GcMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleIAGOO8pmbNycF87w_Ybqp_45spD76rEC87YmYimIBpbfsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexDx0L3_45fNyfg5JK9R572pnX_45IUi_p0dxKnQRsh0L2lk4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsIIcAwCnHYgu6v8SDoC3QjuYYwXJMkF8uF3hQqDkX05IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addP2XGcymFIKJ3bDS3bouUMFBA2uvMQVOQUF_45I6aMUTDQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visueljBeM1ERAgj4Cnzlo3nC6vwGpsM9Y_nz71WNsKclTu1IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexE1zziKIy0fZ_qfhoEiql3Wdux815r0B59RMhc_qsFcYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: index4jIFaX3fgYj2N_45hKe4zAbCV8PzlnC0jAPfDh_45LkAYiYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexeVxIZ9TF06gvYAX1rLUq7tYosw6WkYs9sX2sfSR31KoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addy59XrzIB5KEmxQrGURW_45_I5v936Ys1hAPi74GKYCodwMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addFUnJPhxiuqGIWjx3aUhy_45DKRc8QOqPL2DOO4mEQuko8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addnjXNycnLQKK_458AUgsWiq_45USAnxKshMz44_e10_45ePwOoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexGcTdhJC1m93oEkvkej2mkAt4OohvuH0MO6YN9xzPweAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsDyVIo8V05J5aoM7jzxCkW0nTCxIGMLz7lemSdrzYsesMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editMh2XGfYOIZRFDRF4RojKXN08xoTWufdaqZPSny7ogcEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexJ7qKhX6oIkDJGFyGnNEuK8FGNtamTU04Wcg6TB_LNrsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addgUhckEiuywdyzAKkIgITTEUSrrPP_z5PBiUNuCNcxCoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesb9zIV881KBlBZw_pEBQZtMPgDFVRUTvRw7ISVf4LJkkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editWZoJYwZ_45cmY7LhuLMwzfhj_45v3XZQ6D3hC2F29B2pcUAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursLwK_R1jXAZTRBqHHdu1cpZKbBQGk_45dMiFoGNGwHF7zUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexeyNUU5Qf_45KA9un9KoW5xXsUq5nUlghXrFq5mKYRi_45SwMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexy_lAAEigUQAVTt9N2uMcte_Sivb7cj7ithcxACwDmpwMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendreYpPxImqdFuKIsgbjoHA4SGBEAt6mYPHhVu8QyvQq92IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexY9YgqWw9au2xUnT1GC3FF0IwinVJB4sqTejoGYaZbqYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: adddt9FXVg9SPUKzNIibhEyJPJhuMbtGAa6NllwZm7O48EMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexWQKy__0Ip8e_45XfmhSiJk_YU3ss1yGdhX9x5hbcVUGJIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: edithW86l2DQJzpVTcp2aT_45bN5bw4LgqQYb3Ms0XHvP_LSAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteUqgtnn96Zsbd0umwXLJWXiXm4_6WZTf62uMgTukH4agMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexQ_45M_45wgYh7ZDCJBAR1kS4azxpybgF4DiyeaezB4F9VvkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participations2PyeTKGfELFcgaZK5bnJGrdWLncX11B7y7u3tL8FlicMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsEG7Q1XPHzA1LrejtpbjEJAfWc6jFYjKGaGdfpq2KPmQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editNjsUX4_45DUd8PKNywPv7ucInxIrowCAVOMshPlrj1o90Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexRAByBC9rGsgxxlc0OkY_45IhFiSrPKdk6wtgu1t0SwKmEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsP0WfxwnVPS4yyfe40KDqDvF1JW4XAqNFJoC9gjikTw4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesnTk0q_ib66CXZGkfyvsfUd6y5DnIGdHko6agph5inxMMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editRBi7qPPIqdBT2qgHpu0OfH51usZMJlOjAmnntLhrIfoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexyLimMLC0aV4Q2b10KKZzZFy9Vr_ajxDS5ICSxAT9jkIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexO6_45nM6xSThsODs1gAJSjWPlK1PD8R1_qsus_M3JgLS8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesht4OBZqKDrHyScdxGXS_457ZP2vsNILe9o775U3ph8xzYMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editka1Sjfya7Q0RbLwML3yJ1k_45voYORBvaQcz5vPXgOHCoMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profile9ixpdxGHo5FUZqRZsTQHunL_H_45XaSyAwVS_45Dm1r3h0gMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsOZWX45ZNo4h_wdGiWmoKIJMjigk_UvcrvLb5BW2wos8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editk4tq7YiAFcgjjLewo2TkwS3km1iV6qiYoHseHgpXAEgMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: add8cgfq52YR8RdwquxDJrHcARqgnKr3ouNt7csN2kYaSAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexUR66kYKv4ZSOrpPE5OhfFmDq_l3t6C22oAQzoGVAyLgMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edit6k6Ua1_WkSrMGAL1sxnNQLT723Vfb42lxq7nrU_45oTMcMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsK0E6k5OibOnXGE46W3W73NA_45wgAw5jowASToeQIHCNkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsRKSh3x9eLt6i0Arxt1b2izCdPqaCGii9o_45bMjPtyw4YMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingsESntuq_uPq2g2jS4WlT9U92_36XdSBEYBmbP6pUq6oMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexSSmFmiKVcgTahMl_hmrq9L6uoGvf9e9l9Kn1OKiBp8MMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editufKpGbiockZhUZl_0ptYe_tkzvTPNhvAd38ynK8l8KIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: index5uafpWu1KAFNl28ChqLGLgVYVMhqDHY8BkYMS_17FI0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profilez7uOOPPu5Xowpu8DFfciTfYVb9nndEzMOZgSpn4xmskMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexxsE4rN6nbKdMpgNw4pouO8K3MxkSg0vhb20PnwnH0noMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editIXsSHe8WWtJGWcT3sqiTADGWA7vEHx2jz9QXtgG7ZXQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addzcPEJXtB0OUSRP3Z0SIZNp_45ab1bYO5Dr19DQH3aerf8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesmI8wTwI70tPHvxdJu66D3o9qjabcntQUvytADnrc4EAMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesofHDPuZ6I3AYgNdIbS_Nq4DNBfoz1ZFn5dRg6z7Gl_45IMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45users_45CukM_YwIXeKCqqR5dL7eCywvBu8UrU7H_45KHfruqai0Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresJ0_45jaP1QVb4XhPktHWzlMAz_45bDunfTJIHY7hxLPo5moMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationknr3rdKT1mZuyrLnk1_45j79CHsGj9_45csnPnxt8pC8z_oMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedUtXOAJqyXDYoo_mXUncxVr9Scl6Uz6oBd392s7sm8hEMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsTCYxJWNCRKGGVGj_ViIcm2EDbNUB4XjZJbsNh_zE4okMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45rolexDnvi8zbeANGS0tmhplX8i8grFy5YOCwS2aY3FA9L_wMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsDY6c3dHfbvBwkZUxJLJVtoV_45CremJ8X9jJRMTVdJN0YMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editIV6g1Q9LPvDXwhjV12lb51OtBxI_Y5I2aZxvDLRczX4Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilites9YiiiwDYASxh9gdCMqKTOWP5hB3Fx2HYK2Cp6_45gezJUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkTf_45PcYT8Ws9frBnjfzPepW42oXh7iFdykj1skQhaPbUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index_yAvIJCYoo729x6rSoKapzUZvM4rgQN75X5AhIumXjUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivite31AJyQkf01AnvRWdQDRvC4InZk96ybeRZNCoAAJmlrIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationQmkEz2QhoOGKYQI243Yiu3WQ_QKcwKtjDlDNtoYab0oMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informations4dkd9lMKi_bJOpspooP9N7x2QtAfFznh7HXPX81D7U8Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantOMcDlPKDQ2P10pw05yaWWuUwVwm_29t4zRK3oMq7ZhsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortant1sRhoDd6jXW_4508nR1G99dwaFUFxudqxuGTYCXeOmFvMMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexjd8QoYXVqlm3r_45P4XlHiMnt3Z_Bto9sA9aJYvtI0KaUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesa2aXCqbGGBYI6mEv1zl3DOqGmv8KLXNdkOhuWA_45hWDQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerlF4ECvJut_45tpmx54C4IzXjrIGUXCcNPLotHGuhDhH8wMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesUlkvf5aKdbQ4baegHbsLs7QI9_DhWyv1tu7ddRoqH6QMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesQW9QBHKUAmhKmEb3fNfYSPfzGDc7IdB4Fz2HNmGvuGkMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsmO3_DKD6H1_45xqpJRf4njsy5EQjKt7vFlSddlcYk2SjIMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedLrX7iKG_45qkMVBAoJVINK_45jDvKgaUCRPirYWn_xBYUCQMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valider8wXgrsnCj7asxtxQkm9H1Z2SkMPE4jLWR_fbMqKT_ykMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationDR7luGtiBt3toOnI6P_45Ywyog7r4QEwAulZOPB2C1T8MMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationtuOl5BBU4_TWfni6y9LibB6AofTsj5jjrFiJL89ZX60Meta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerusQBbC5laCVfYDeNoO1PIGzXj5RJJLnL622S_BjKfjsMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesT6cB7vptXVm6Pg16QBz6xtPmHWR6yqmTLCJoat7yPvUMeta || {},
    component: () => import("/build/02e315cd-ad93-4b7b-9992-b38b66e1aa7b/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/user/settings",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/statistiques",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  },
  {
    name: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4JgoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubuXlUg27saGgvFopM4Pz33c4J4R1nVbadwUbfvJJ4Jgo
  }
]